import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';

import '@shared/utils/i18n';
import App from './app';
import { store } from '@shared/store';
import '@shared/services/apiService/enhanceApi';
import Spinner from '@shared/components/spinner/Spinner';
import { ErrorBoundaryFallback } from '@shared/components/ErrorBoundary';
import { initPopupPopstateGuard } from '@shared/hooks/popstateGuard';
import {
  sentryDsn,
  sentryEnvironment,
  sentryRelease,
  sentryTracesSampleRate,
} from '@shared/utils/runtimeConfig';

Sentry.init({
  dsn: sentryDsn,
  integrations: [Sentry.browserTracingIntegration()],
  environment: sentryEnvironment,
  release: sentryRelease,
  tracesSampleRate: sentryTracesSampleRate,
});

initPopupPopstateGuard();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => (
      <ErrorBoundaryFallback error={error} resetError={resetError} />
    )}>
    <HelmetProvider>
      <Provider store={store}>
        <Suspense fallback={<Spinner />}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Suspense>
      </Provider>
    </HelmetProvider>
  </Sentry.ErrorBoundary>,
);
